(() => {
  if (customElements.get("video-carousel")) return;

  class VideoCarousel extends HTMLElement {
    constructor() {
      super();

      // Scope all elements to this component instance
      this.swiperEl = this.querySelector(".swiper");
      this.nextButton = this.querySelector(".swiper-button-next");
      this.prevButton = this.querySelector(".swiper-button-prev");
      this.paginationEl = this.querySelector(".swiper-pagination");

      this.swiper = null;
    }

    connectedCallback() {
      // Avoid double‑initialization if the element is re‑connected
      if (this.swiper) return;

      // Ensure Swiper is available and we have a container
      if (typeof window === "undefined" || typeof window.Swiper === "undefined") {
        return;
      }
      if (!this.swiperEl) return;

      this._initSwiper();
    }

    disconnectedCallback() {
      // Clean up Swiper instance when element is detached
      if (this.swiper && typeof this.swiper.destroy === "function") {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    _initSwiper() {
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 32,
        navigation: {
          // Pass concrete elements so multiple instances don't conflict
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        pagination: {
          el: this.paginationEl,
          clickable: true,
        },
      });
    }
  }

  customElements.define("video-carousel", VideoCarousel);
})();
